import { EditorState, Transaction } from "prosemirror-state";
import { getTopLevelParagraphsAndHeadings } from "./GetNodes";

function setIndentFactory(step: number) {
	return function setIndent(state: EditorState, dispatch?: (tx: Transaction) => void) {
		if (dispatch) {
			const tr = state.tr;
			let did = false;
			for (const p of getTopLevelParagraphsAndHeadings(state)) {
				const attrs = p.node.attrs;
				const newIndent = attrs.indent + step;
				if (newIndent >= 0 && newIndent <= 12) {
					tr.setNodeMarkup(p.pos, p.node.type, {
						align: attrs.align,
						indent: newIndent,
						...(p.node.attrs.level && { level: p.node.attrs.level }),
					});
					did = true;
				}
			}
			if (did) {
				dispatch(tr.scrollIntoView());
			}
			return did;
		} else {
			for (const p of getTopLevelParagraphsAndHeadings(state)) {
				const attrs = p.node.attrs;
				const newIndent = attrs.indent + step;
				if (newIndent >= 0 && newIndent <= 12) {
					return true;
				}
			}
			return false;
		}
	};
}
/** Increase the indent level of any selected paragraph by 1, to a max of 12 */

export const indent = setIndentFactory(1);
/** Decrease the indent level of any selected paragraph by 1, to a min of 0 */
export const outdent = setIndentFactory(-1);
